import { hasKnownEntityId } from '../utils/entityIdentity';
import FollowOutline from './FollowOutline';
import { useEntityPreference } from './useEntityPreference';
import { useState } from "react";


import { Drawer } from "@mui/material";

import { largeSourceImage } from "./trackHelper";

import CloseFooter from "./CloseFooter";
import ShowPreferenceControl from './ShowPreferenceControl';



const PodcastHeader = ({ podcast }) => {
    const preference = useEntityPreference('show', { ...podcast, source: podcast });
    const followed = hasKnownEntityId(podcast.id) && preference.status === true;

    const [openFullSummary, setOpenFullSummary] = useState(false);

    const toggleFullSummary = (open) => (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        if (!podcast || !podcast.description) {
            return;
        }
        setOpenFullSummary(open);
    }

    function removeHTMLTags(str) {
        return str.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ');
    }

    return (
        <div style={{ paddingTop: '60px' }}>
            <Drawer anchor='bottom' open={openFullSummary} onClose={toggleFullSummary(false)}>
                {!podcast || !podcast.description ? <></> :
                    <div className='horizontalCenter appDrawerSurface' style={{ height: 'var(--app-height, 100svh)' }}>
                        <div className='hasCloseFooter'>
                            <div style={{ padding: '20px' }}>
                                <div className='heading'>
                                    Description
                                </div>
                                <div style={{ paddingTop: '10px' }}>
                                    {removeHTMLTags(podcast.description)}
                                </div>
                            </div>
                        </div>

                    </div>
                }
                <CloseFooter onClick={toggleFullSummary(false)} />
            </Drawer>

            <div className='entityHeaderCard entityHeaderCardPodcast'>
                <div className='podcastHeaderArtwork'>
                    <FollowOutline followed={followed}>
                        <img src={largeSourceImage(podcast.imageURL)} alt={`${podcast.name}${followed ? ", followed" : ""}`} className='largeSourceImage' />
                    </FollowOutline>
                </div>

                <div className='entityHeaderText'>
                    <div className='podcastNameLarge'>
                        {podcast.name}
                    </div>

                    {!podcast || !podcast.description ?
                        <></>
                        :
                        <button
                            onClick={toggleFullSummary(true)}
                            className='podcastSummaryButton podcastHeaderSummaryButton'>
                            <div className='podcastSummary'>
                                {removeHTMLTags(podcast.description)}
                            </div>
                        </button>
                    }
                </div>

                <div className='entityHeaderSubscribe'>
                    <ShowPreferenceControl
                        status={preference.status}
                        onStatusChange={preference.change}
                        variant='labeled'
                        mutation={preference.mutation}
                        onRetry={() => preference.change(preference.mutation.status)}
                    />
                </div>
            </div>
        </div>
    );
};

export default PodcastHeader;
